import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
const terms = ['Simple refund', 'No forms to fill', 'Keep all bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="bg-paper py-16 sm:py-24" data-id="element-125" data-mp="223y2kzo0jtgf">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-126" data-mp="1x4l9vyagns5x">
        <div className="grid gap-8 border border-paper-300 bg-paper-100 p-6 sm:p-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,20rem)] lg:gap-16" data-id="element-127" data-mp="1x54op64te0fq">
          <div data-id="element-128" data-mp="14fxq675d1auh">
            <div className="flex items-center gap-3" data-id="element-129" data-mp="14gfod9bl1z51">
              <ShieldCheckIcon className="h-5 w-5 text-brass" aria-hidden="true" data-id="element-130" data-mp="14dteh317z7jn" />
              <Eyebrow data-id="element-131" data-mp="1j5vb8e7ztkfg">Zero risk &middot; 100% protected</Eyebrow>
            </div>
            <h2 id="guarantee-heading" className="mt-5 font-display text-3xl font-semibold leading-tight text-ink sm:text-5xl" data-id="element-132" data-mp="1ec97jbjt4qvs">
              7-day money-back guarantee
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-ink-soft" data-id="element-133" data-mp="ln27270slr7w">
              Open everything. Use the materials. Test it in your classes. If Jazz Teacher&rsquo;s
              Arsenal doesn&rsquo;t transform how you plan and teach jazz, we&rsquo;ll refund every
              dollar &mdash; no questions asked.
            </p>
          </div>

          <div className="flex flex-col justify-center border-t border-paper-300 pt-8 lg:border-l lg:border-t-0 lg:pl-12 lg:pt-0" data-id="element-134" data-mp="12pmsavg0sc77">
            <ul className="space-y-3" data-id="element-135" data-mp="62qk6taayjxg">
              {terms.map(term => <li key={term} className="text-sm uppercase tracking-label text-ink-soft" data-id="element-136" data-mp="b0a6mgh5m30h">
                  {term}
                </li>)}
            </ul>
            <p className="mt-8 font-display text-xl leading-snug text-brass-dark" data-id="element-137" data-mp="k0otvldohs6m">
              Satisfaction guaranteed, or your money back.
            </p>
          </div>
        </div>
      </div>
    </section>;
}